import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { BreezeLoader, BreezeLoaderMotion } from 'ai-components-ui-library/components/loading/BreezeLoader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// When a new tool is added to the agent, add an entry here and a corresponding
// key under academy-ai-assistant.chat.tools in en.lyaml. Unmapped tools fall
// back to "Working on it...".
const TOOL_MESSAGES = {
  AcademyCatalogTools_getCatalogItemInformation: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.getCatalogItemInformation"
  }),
  AcademyCatalogTools_getCertificates: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.getCertificates"
  }),
  AcademyCatalogTools_getProfessorInformation: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.getProfessorInformation"
  }),
  AcademyCatalogTools_getRecommendations: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.getRecommendations"
  }),
  AcademyCatalogTools_getTranscript: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.getTranscript"
  }),
  AcademyCatalogTools_titleSearch: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.titleSearch"
  }),
  AcademySuggestionTools_createSuggestionButtons: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.createSuggestionButtons"
  }),
  AcademyPlaylistTools_generatePlaylist: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.generatePlaylist"
  }),
  HubspotKnowledgeTools_getDocumentDetails: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.getDocumentDetails"
  }),
  HubspotKnowledgeTools_queryV3: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.queryKnowledge"
  }),
  HubspotKnowledgeTools_queryV4: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.queryKnowledge"
  }),
  load_skill: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academy-ai-assistant.chat.tools.loadSkill"
  })
};
const FALLBACK_MESSAGE = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "academy-ai-assistant.chat.thinkingLabels.workingOnIt"
});
const toReadableLabel = toolName => {
  if (toolName) {
    const message = TOOL_MESSAGES[toolName];
    if (message) return message;
  }
  return FALLBACK_MESSAGE;
};
export const ToolCallProgress = ({
  tools = [],
  fallbackLabel
}) => {
  if (tools.length === 0 && !fallbackLabel) return null;
  const activeLabel = tools.length > 0 ? toReadableLabel(tools[tools.length - 1].name) : fallbackLabel;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    role: "status",
    "aria-live": "polite",
    children: [/*#__PURE__*/_jsx(BreezeLoader, {
      size: 16,
      motion: BreezeLoaderMotion.WORKING
    }), /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      color: "text-core-subtle",
      children: activeLabel
    })]
  });
};